import React, { Component } from 'react';
import PropTypes from 'prop-types';
import counterpart from 'counterpart';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import ruRU from 'antd/lib/locale-provider/ru_RU';

import LanguageContext from './context/LanguageContext';

const locales = {
    ru: ruRU,
    en: enUS
};

export default class LanguageProvider extends Component {
    static propTypes = {
        children: PropTypes.node,
    }

    constructor(props) {
        super(props);

        this.state = {
            language: counterpart.getLocale()
        };
    }

    componentDidMount() {
        counterpart.onLocaleChange(this.changeLanguage);
    }

    componentWillUnmount() {
        counterpart.offLocaleChange(this.changeLanguage);
    }

    changeLanguage = language => {
        this.setState({ language });
    }

    getCurrentLocale() {
        return locales[this.state.language];
    }

    render() {
        return (
            <ConfigProvider locale={this.getCurrentLocale()}>
                <LanguageContext.Provider value={this.state.language}>
                    { this.props.children }
                </LanguageContext.Provider>
            </ConfigProvider>
        );
    }
}
